import { mapActions, mapState } from 'pinia'
import { useProductStore } from '../pinia/ProductStore'

const isModifiedClick = event => event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey

export const cansOptionSelect = {
  computed: {
    ...mapState(useProductStore, ['cansSelection', 'selectedCansOptions', 'cansCell', 'isCansOptionSelected']),

    cansLive () {
      return Boolean(this.cansSelection) && Object.keys(this.selectedCansOptions).length > 0
    },
  },

  methods: {
    ...mapActions(useProductStore, ['selectCansOption']),

    cell (position, optionValueId) {
      return this.cansLive ? this.cansCell(position, optionValueId) : null
    },

    item (position, optionValueId, ssrState) {
      let state = ssrState
      const attributes = {}
      if (this.cansLive) {
        const cell = this.cansCell(position, optionValueId)
        const active = this.isCansOptionSelected(position, optionValueId)
        state = [active && 'is-active', cell && !cell.available && 'is-oos'].filter(Boolean).join(' ')
        attributes['aria-checked'] = String(active)
      }

      // `^` sets the attribute, replacing the SSR state classes instead of merging with them.
      attributes['^class'] = [this.$options.itemClass, state].filter(Boolean).join(' ')
      return attributes
    },

    linked (position, optionValueId, ssrLinked) {
      return this.cansLive ? Boolean(this.cansCell(position, optionValueId)) : ssrLinked
    },

    link (position, optionValueId) {
      if (!this.cansLive) return {}

      const cell = this.cansCell(position, optionValueId)
      return {
        href: cell ? cell.url : this.combinationUrl(position, optionValueId),
        'data-variant-id': cell ? cell.variantId : null,
      }
    },

    combinationUrl (position, optionValueId) {
      const options = { ...this.selectedCansOptions, [position]: String(optionValueId) }
      const params = new URLSearchParams(window.location.search)
      params.set('option_values', Object.keys(options).sort((a, b) => a - b).map(key => options[key]).join(','))
      return `${window.location.pathname}?${params}`
    },

    select (event, position, optionValueId) {
      if (isModifiedClick(event)) return
      if (this.isCansOptionSelected(position, optionValueId) || this.selectCansOption(position, optionValueId)) {
        event.preventDefault()
      }
    },

    activate (event) {
      event.preventDefault()
      event.currentTarget.querySelector('a[href]')?.click()
    },
  },
}
